import { Link } from 'react-router-dom'
import './Footer.css'
import { useSiteContent } from '../../../context/SiteContentContext'
import { field, mediaGroup, mediaSrc, numbered } from '../../../utils/cms'

function FooterLink({ to, label }) {
  if (!to || to === '#') {
    return <span className="footer__link">{label}</span>
  }
  if (to.startsWith('/')) {
    return (
      <Link to={to} className="footer__link">
        {label}
      </Link>
    )
  }
  return (
    <a href={to} className="footer__link">
      {label}
    </a>
  )
}

const Footer = () => {
  const { footer } = useSiteContent()
  if (!footer) return null

  const logo = mediaSrc(footer, 'logo')
  const mark = mediaSrc(footer, 'mark')
  const socialIcons = mediaGroup(footer, 'socials')
  const socials = numbered(footer, 'social', ['Label', 'Url']).map((item, i) => ({
    ...item,
    icon: socialIcons[i]?.src,
  }))
  const columns = numbered(footer, 'column', ['Title']).map((column) => ({
    ...column,
    links: numbered(footer, `column${column.index}Link`, ['Label', 'Url']),
  }))

  return (
    <footer className="footer">
      <div className="footer__glow footer__glow--left" aria-hidden />
      <div className="footer__glow footer__glow--right" aria-hidden />

      <div className="footer__container">
        <div className="footer__main">
          <div className="footer__brand">
            <Link to="/" className="footer__logo-link">
              {logo ? (
                <img src={logo} alt="Tevris" className="footer__logo" />
              ) : null}
            </Link>
            <p className="footer__brand-text">{field(footer, 'brandText')}</p>
            <ul className="footer__socials">
              {socials.map(({ label, url, icon, index }) => (
                <li key={`${label}-${index}`}>
                  <a href={url || '#'} className="footer__social-link" aria-label={label}>
                    {icon ? (
                      <img src={icon} alt="" className="footer__social-icon" />
                    ) : null}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__columns">
            {columns.map((column) => (
              <nav
                key={column.index}
                className="footer__column"
                aria-label={column.title}
              >
                <h3 className="footer__column-title">{column.title}</h3>
                <ul className="footer__links">
                  {column.links.map((link) => (
                    <li key={`${link.label}-${link.index}`}>
                      <FooterLink to={link.url} label={link.label} />
                    </li>
                  ))}
                </ul>
              </nav>
            ))}
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">{field(footer, 'copyright')}</p>
          {mark ? <img src={mark} alt="" className="footer__mark" /> : null}
        </div>
      </div>
    </footer>
  )
}

export default Footer
